import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class LanguageInterceptor implements HttpInterceptor {
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const selectedLang = location.pathname.indexOf('/en') > -1 ? 'en' : 'lv';

        const req = request.clone({
            setHeaders: {
                AppSelectedLang: selectedLang
            }
        });

        return next.handle(req).pipe(
            catchError((error) => {
                return throwError(error);
            })
        );
    }
}
